<form [formGroup]="documentForm" class="document-container app__select--text--size">
  <div formArrayName="dynamicFieldsForm" class="justify-between flex flex-wrap p-0">
    @for (arrayItem of arrayItems; track arrayItem; let i = $index) { @if (!arrayItem?.excludedFromOnboarding) {
    <div
      [formGroupName]="'0'"
      [ngStyle]="{ width: arrayItem?.width ? (arrayItem?.width == '99%' ? '100%' : arrayItem?.width) : '100%' }"
      class="dynamic-form-field-container"
    >
      @if (arrayItem?.type == 'Section' && arrayItem.label != 'General Information' && !hide_description_Section) {
      <label style="color: #25508e" class="array-item-title section-lable"
        >{{ arrayItem.label }}
        @if (arrayItem?.label) {
        <span matTooltip="Fields displayed are based on the selected template." class="material-icons relative inset-y-0 text-xs">info</span>
        }
      </label>
      } @if (arrayItem?.type == 'email' ) {
      <div class="mb-3" style="width: 100% !important">
        <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
          @if (arrayItem?.label) {
          <mat-label class="automtic-form-desing-lable">
            {{ arrayItem.label }}
            @if (arrayItem?.isRequired) {
            <span class="automtic-form-desing-required-sign"> * </span>
            }
          </mat-label>
          }
          <input matInput [placeholder]="arrayItem?.placeholder" type="email" [formControlName]="arrayItem?.formControlName" />
        </mat-form-field>
      </div>
      } @if (arrayItem?.type == 'text') {
      <div class="mb-3" style="width: 100% !important">
        @if (arrayItem?.label) {
        <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
          <mat-label class="automtic-form-desing-lable">
            {{ arrayItem.label }}
            @if (arrayItem?.isRequired) {
            <span class="automtic-form-desing-required-sign"> * </span>
            }
          </mat-label>
          @if (arrayItem?.makeEyeField) {
          <input
            matInput
            [placeholder]="arrayItem?.placeholder"
            [type]="arrayItem.setDefaultEyeField ? 'text' : 'text'"
            [formControlName]="arrayItem?.formControlName"
            [ngClass]="{ 'mask-input-text': arrayItem.setDefaultEyeField }"
          />
          } @if (!arrayItem?.makeEyeField) {
          <input matInput [placeholder]="arrayItem?.placeholder" [formControlName]="arrayItem?.formControlName" />
          } @if (arrayItem?.makeEyeField) {
          <button mat-icon-button matSuffix (click)="clickNt(i)" [attr.aria-label]="'Hide password'">
            <mat-icon>{{ arrayItem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }} </mat-icon>
          </button>
          }
        </mat-form-field>
        }
      </div>
      } @if (arrayItem?.type == 'number') {
      <div class="mb-3" style="width: 100% !important">
        <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
          @if (arrayItem?.label) {
          <mat-label class="automtic-form-desing-lable">
            {{ arrayItem.label }}
            @if (arrayItem?.isRequired) {
            <span class="automtic-form-desing-required-sign"> * </span>
            }
          </mat-label>
          }
          <input
            matInput
            id="target"
            [placeholder]="arrayItem?.placeholder"
            pattern="\d+"
            [type]="arrayItem.setDefaultEyeField ? 'text' : 'text'"
            [ngClass]="{ 'mask-input-text': arrayItem.setDefaultEyeField }"
            [formControlName]="arrayItem?.formControlName"
          />
          @if (arrayItem?.makeEyeField) {
          <button mat-icon-button matSuffix (click)="clickNt(i)" [attr.aria-label]="'Hide password'">
            <mat-icon>{{ arrayItem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }} </mat-icon>
          </button>
          }
        </mat-form-field>
      </div>
      } @if (arrayItem?.type == 'date') {
      <div class="mb-3" style="width: 100% !important">
        @if(!afterViewInit){
        <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
          @if (arrayItem?.label) {
          <mat-label class="automtic-form-desing-lable">
            {{ arrayItem.label }}
            @if (arrayItem?.isRequired) {
            <span class="automtic-form-desing-required-sign"> * </span>
            }
          </mat-label>
          }
          <input
            matInput
            [matDatepicker]="dp3"
            (dateChange)="(arrayItem.triggerType)"
            (click)="dp3.open()"
            [formControlName]="arrayItem?.formControlName"
          />
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3 disabled="false"></mat-datepicker> </mat-form-field
        >}@else{
        <reusable-date-input
          [title]="arrayItem?.label"
          [controlName]="arrayItem?.formControlName"
          [value]="documentForm.controls['dynamicFieldsForm'].value[0][arrayItem?.formControlName]"
          (dateChangeEmitter)="handleDateChange($event, arrayItem?.formControlName)"
          (changeEmitter)="handleDateChange2($event, arrayItem?.formControlName)"
          [hasClassTruncate]="true"
          [floatLabel]="'auto'"
          style="width: 100% !important; display: contents"
          [classStyle]="'automtic-form-desing-form-only truncate-date-form-input'"
          [isRequired]="arrayItem?.isRequired"
          [labelClass]="'truncate-label'"
        >
        </reusable-date-input
        >}
      </div>
      } @if (arrayItem?.type == 'select') {
      <div class="mb-3" style="width: 100% !important">
        <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
          <mat-label class="automtic-form-desing-lable">
            {{ arrayItem.label }}
            @if (arrayItem?.isRequired) {
            <span class="automtic-form-desing-required-sign"> * </span>
            }
          </mat-label>
          <mat-select matNativeControl disableOptionCentering [placeholder]="arrayItem?.placeholder" [formControlName]="arrayItem?.formControlName">
            @for (item of arrayItem?.options; track item) {
            <mat-option [value]="item?.value">
              {{ item?.label }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      } @if (arrayItem?.type == 'largeText' && arrayItem?.label != 'Description') {
      <div class="mb-3" style="width: 100% !important">
        <ngx-editor-field
          [arrayItem]="arrayItem"
          [formControlValue]="documentForm.controls.dynamicFieldsForm.controls[0].controls[arrayItem?.formControlName].value"
        >
        </ngx-editor-field>
      </div>
      } @if (arrayItem?.type == 'checkBox') {
      <div class="mb-3" style="height: 45.93px !important; padding-top: 10px">
        <mat-checkbox class="automatic-form-checkbox" [formControlName]="arrayItem?.formControlName">
          <mat-label class="automtic-form-desing-lable">
            {{ arrayItem.label }}
            @if (arrayItem?.isRequired) {
            <span class="automtic-form-desing-required-sign"> * </span>
            }
          </mat-label>
        </mat-checkbox>
      </div>
      }
    </div>
    } }
  </div>
  @if (askSecurityQuestion) {
  <div class="justify-between flex flex-wrap p-0">
    <mat-slide-toggle (click)="toggleActive($event)" [checked]="isEnableForm" id="toggleActive">
      <mat-label class="automtic-form-desing-lable"> This account has security questions </mat-label>
    </mat-slide-toggle>
  </div>
  } @if (isEnableForm) {
  <div class="">
    @for (arrayItem of beneFicaryForm; track arrayItem; let i = $index) {
    <div formArrayName="beneFicaryForm" class="justify-between flex flex-wrap p-0 mt-6">
      <h3 class="" style="margin-bottom: 12px; width: 100% !important">
        {{ arrayItem.SectionTitle }}
      </h3>
      <div [formArrayName]="i" style="width: 100% !important">
        <div [formArrayName]="arrayItem?.formControlName" class="remove-maring-right-mobile">
          @for (skill of templateList(i, arrayItem?.formControlName).controls; track skill; let skillIndex = $index) {
          <div class="border bg-white rounded-lg mb-3 pt-1.5 pl-1.5">
            <div class="flex justify-between px-1">
              <p id="beneficary-section" style="font-size: 14; font-weight: 400">{{ arrayItem.Singularname }} No. {{ skillIndex + 1 }}</p>
              <span
                (click)="removeBeneficary(arrayItem.formControlName, i, skillIndex)"
                style="position: relative; right: 6px"
                class="material-icons dust-bin-icon text-[#EB5757] cursor-pointer"
                >delete</span
              >
            </div>
            <div [formGroupName]="skillIndex" class="mobile-form-container flex-container">
              @for (childitem of arrayItem?.template; track childitem) {
              <div
                class="dynamic-form-field-container"
                [ngStyle]="{ width: childitem?.width ? (childitem?.width == '100%' ? '99%' : childitem?.width) : '99%' }"
              >
                @if (childitem?.type == 'Section') {
                <label style="color: #25508e" class="array-item-title section-lable">{{ childitem.label }} </label>
                } @if (childitem?.type == 'text') {
                <div style="width: 100% !important">
                  @if (childitem?.label) {
                  <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
                    <mat-label class="automtic-form-desing-lable">
                      {{ childitem.label }}
                      @if (childitem?.isRequired) {
                      <span class="automtic-form-desing-required-sign"> * </span>
                      }
                    </mat-label>
                    @if (childitem?.makeEyeField) {
                    <input
                      matInput
                      [placeholder]="childitem?.placeholder"
                      [type]="childitem.setDefaultEyeField ? 'text' : 'text'"
                      [formControlName]="childitem?.formControlName"
                      [ngClass]="{ 'mask-input-text': childitem.setDefaultEyeField }"
                    />
                    } @if (!childitem?.makeEyeField) {
                    <input matInput [placeholder]="childitem?.placeholder" [formControlName]="childitem?.formControlName" />
                    } @if (childitem?.makeEyeField) {
                    <button
                      mat-icon-button
                      matSuffix
                      (click)="childitem.setDefaultEyeField = !childitem.setDefaultEyeField"
                      [attr.aria-label]="'Hide password'"
                    >
                      <mat-icon>{{ childitem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }} </mat-icon>
                    </button>
                    }
                  </mat-form-field>
                  }
                </div>
                } @if (childitem?.type == 'date') {
                <div style="width: 100% !important">
                  @if(!afterViewInit){
                  <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
                    @if (childitem?.label) {
                    <mat-label class="automtic-form-desing-lable">
                      {{ childitem.label }}
                      @if (childitem?.isRequired) {
                      <span class="automtic-form-desing-required-sign"> * </span>
                      }
                    </mat-label>
                    }
                    <input matInput [matDatepicker]="dp3" (click)="dp3.open()" [formControlName]="childitem?.formControlName" />
                    <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                    <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                  </mat-form-field>
                  }@else{
                  <reusable-date-input
                    [title]="childitem?.label"
                    [controlName]="childitem?.formControlName"
                    [value]="documentForm.controls['dynamicFieldsForm'].value[0][childitem?.formControlName]"
                    (dateChangeEmitter)="handleDateChange($event, childitem?.formControlName)"
                    (changeEmitter)="handleDateChange2($event, childitem?.formControlName)"
                    [hasClassTruncate]="true"
                    [floatLabel]="'auto'"
                    style="width: 100% !important; display: contents"
                    [classStyle]="'automtic-form-desing-form-only truncate-date-form-input'"
                    [isRequired]="childitem?.isRequired"
                    [labelClass]="'truncate-label'"
                  >
                  </reusable-date-input
                  >}
                </div>
                } @if (childitem?.type == 'number') {
                <div style="width: 100% !important">
                  <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
                    @if (childitem?.label) {
                    <mat-label class="automtic-form-desing-lable">
                      {{ childitem.label }}
                      @if (childitem?.isRequired) {
                      <span class="automtic-form-desing-required-sign"> * </span>
                      }
                    </mat-label>
                    }
                    <input
                      matInput
                      [placeholder]="childitem?.placeholder"
                      id="target"
                      pattern="\d+"
                      type="text"
                      [formControlName]="childitem?.formControlName"
                    />
                  </mat-form-field>
                </div>
                } @if (childitem?.type == 'select') {
                <div style="width: 100% !important">
                  <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
                    <mat-label class="automtic-form-desing-lable">
                      {{ childitem.label }}
                      @if (childitem?.isRequired) {
                      <span class="automtic-form-desing-required-sign"> * </span>
                      }
                    </mat-label>
                    <mat-select matNativeControl disableOptionCentering [formControlName]="childitem?.formControlName">
                      @for (item of childitem?.options; track item) {
                      <mat-option [value]="item?.value">
                        {{ item?.label }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                } @if (childitem?.type == 'email') {
                <div style="width: 100% !important">
                  <mat-form-field appearance="fill" style="width: 100% !important" floatLabel="auto" class="automtic-form-desing-form-only">
                    @if (childitem?.label) {
                    <mat-label class="automtic-form-desing-lable">
                      {{ childitem.label }}
                      @if (childitem?.isRequired) {
                      <span class="automtic-form-desing-required-sign"> * </span>
                      }
                    </mat-label>
                    }
                    <input matInput [placeholder]="childitem?.placeholder" type="email" [formControlName]="childitem?.formControlName" />
                  </mat-form-field>
                </div>
                } @if (childitem?.type == 'largeText') {
                <div style="width: 100% !important">
                  <mat-form-field appearance="fill" style="width: 100% !important" floatLabel="auto" class="automtic-form-desing-form-only">
                    @if (childitem?.label) {
                    <mat-label class="automtic-form-desing-lable">
                      {{ childitem.label }}
                      @if (childitem?.isRequired) {
                      <span class="automtic-form-desing-required-sign"> * </span>
                      }
                    </mat-label>
                    }
                    <textarea
                      matInput
                      [placeholder]="childitem?.placeholder"
                      maxlength="1500"
                      cdkAutosizeMinRows="5"
                      style="overflow: hidden; height: auto !important; min-height: 16px !important"
                      matTextareaAutosize
                      [formControlName]="childitem?.formControlName"
                    >
                    </textarea>
                  </mat-form-field>
                </div>
                } @if (childitem?.type == 'checkBox') {
                <div style="height: 45.93px !important; padding-top: 10px">
                  <mat-checkbox class="automatic-form-checkbox" [formControlName]="childitem?.formControlName">
                    <mat-label class="automtic-form-desing-lable">
                      {{ childitem.label }}
                      @if (childitem?.isRequired) {
                      <span class="automtic-form-desing-required-sign"> * </span>
                      }
                    </mat-label>
                  </mat-checkbox>
                </div>
                }
              </div>
              }
            </div>
          </div>
          }
        </div>
      </div>
      @if (beneFicaryForm?.length >= 1 ) {
      <button (click)="addBeneficiarybyform(arrayItem.formControlName, i)" class="bg-transparent text-[#25508E] text-base font-semibold">
        <mat-icon class="relative top-1">add </mat-icon>
        Add {{ arrayItem.Singularname }}
      </button>
      }
    </div>
    }
  </div>
  }
</form>
@if(showCopyDataButton && arrayItems?.length){
<div class="app__common--copy--btn app__centered-item app__form--attribute--title mt-3" (click)="copyDataFromLiveFeeds()">
  <span> Copy data from {{ buttonDisplayText }} </span>
</div>
}
